// extracted by mini-css-extract-plugin
module.exports = {"root":"PetTypeChip_root__nkf-o","dogs":"PetTypeChip_dogs__1TX-4","cats":"PetTypeChip_cats__1hdQr","exotics":"PetTypeChip_exotics__2SUZ4"};